export default __webpack_public_path__ + "1884663175be90ee1ec4552441d6516b.png";